import { render, staticRenderFns } from "./MentionableTextarea.vue?vue&type=template&id=cf0c2ab6&scoped=true&"
import script from "./MentionableTextarea.vue?vue&type=script&lang=js&"
export * from "./MentionableTextarea.vue?vue&type=script&lang=js&"
import style0 from "./MentionableTextarea.vue?vue&type=style&index=0&id=cf0c2ab6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf0c2ab6",
  null
  
)

export default component.exports